import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bitrix24',
  templateUrl: './bitrix24.component.html',
  styleUrls: ['./bitrix24.component.css']
})
export class Bitrix24Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
